export default {"src":"/_next/static/media/twitterIconBlue.dda33d1f.svg","height":204,"width":248};